export default __webpack_public_path__ + "static/media/textures.d890ed85.png";